import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Dialog} from "primereact/dialog";

import FulfillmentItemListService from "../../services/fulfillment/FulfillmentItemListService";
import FulfillmentItemFormComponent from "./FullfillmentItemFormComponent";
import FulfillmentFormComponent from "./FullfillmentFormComponent";
import currencyFormatter from "currency-formatter";

const FulfillmentItemListComponent = (props) => {

  const [items, setItems] = useState(false);
  const [loading, setLoading] = useState(false);
  const dt = useRef(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      window.App.setState({rerenderFulfillmentItemList: false})
      FulfillmentItemListService(props.fulfillmentId, JSON.stringify(lazyParams))
        .then(response => {
          setTotalRecords(response.data.total_item_count);
          setItems(response.data.items);
          setLoading(false);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-mr-2"
                tooltip="Módosítás"
                onClick={() => {
                  window.App.setState({
                    fulfillmentItemRowData: rowData,
                    dialogFullfillmentItemUpdate: true,
                  })
                }}/>
        {/*<Button icon="pi pi-trash" className="p-button-sm  p-button-danger"*/}
        {/*        tooltip="Törlés"*/}
        {/*        onClick={() => {*/}
        {/*          if (window.confirm('A törlés megerősítésére van szükség!')) {*/}
        {/*            deleteFulfillment(rowData)*/}
        {/*          }*/}
        {/*        }}*/}
        {/*/>*/}
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderFulfillmentItemList === true])

  return (
    <>
      <DataTable
        emptyMessage="Nincs találat."
        value={items} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows} emptyMessage="Nincs találat."
        autoLayout={true}
        filterDisplay="row"
        responsiveLayout="scroll"
        stripedRows
        ref={dt}
        dataKey="id"
      >
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap"}></Column>
        <Column field="name" header="Név" sortable filter filterPlaceholder="Név"></Column>
        <Column field="projectActionName" header="Projekt tétel" sortable filter
                filterPlaceholder="Projekt tétel"></Column>
        <Column field="netAmount" header="Nettó érték" className={"p-text-right p-text-nowrap"}
                body={(rowData) => {
                  let currency
                  currency = {
                    precision: 2,
                    symbol: '',
                    decimal: ',',
                    thousand: ' ',
                  }

                  return (
                    <>
                      {currencyFormatter.format(
                        rowData.netAmount, {
                          precision: currency.precision,
                          symbol: currency.symbol,
                          decimal: currency.decimal,
                          thousand: currency.thousand,
                        }
                      )
                      }
                    </>
                  )
                }}></Column>
        <Column field="quantity" header="Mennyiség" className={"p-text-right"} body={(rowData) => {
          return (
            <>
              {rowData.quantity} {rowData.unitName}
            </>
          )
        }}></Column>
      </DataTable>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col-12 p-lg-6 p-xl-6"}>
        </div>
        <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
          <Button type="button" label="Teljesítés tétel hozzáadása" icon="pi pi-plus"
                  className="p-button-success p-ml-2"
                  onClick={() => {
                    window.App.setState({
                      dialogFullfillmentItemCreate: true,
                    })
                  }}
          />
          <Dialog visible={window.App.state.dialogFullfillmentItemCreate}
                  style={{width: '750px'}}
                  header="Teljesítés tétel hozzáadása"
                  modal
                  onHide={() => {
                    window.App.setState({
                      dialogFullfillmentItemCreate: false
                    })
                  }}>
            <FulfillmentItemFormComponent projectId={window.App.state.props.id} fulfillmentId={props.fulfillmentId}/>
          </Dialog>
        </div>
      </div>
      <Dialog visible={window.App.state.dialogFullfillmentItemUpdate}
              style={{width: '750px'}}
              header="Teljesítés tétel  módosítása"
              modal
              onHide={() => {
                window.App.setState({
                  dialogFullfillmentItemUpdate: false
                })
              }}>
        <FulfillmentItemFormComponent projectId={window.App.state.props.id} fulfillmentId={props.fulfillmentId}
                                      initialValues={window.App.state.fulfillmentItemRowData}/>
      </Dialog>
    </>
  )
}
export default withTranslation('common')(FulfillmentItemListComponent);
